// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { Tile, TileSize } from '../../_components/ui';
import { InnerGridWrapper } from '../_partials';
import { TeaserBoxInnerGrid, TeaserBoxVersion } from '../TeaserBox.contracts';
/**
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
let TeaserBoxInnerGridL8S = class TeaserBoxInnerGridL8S extends TeaserBoxInnerGrid {
    constructor() {
        super(...arguments);
        this.tileConfig = {
            [TileSize.S]: {
                isPremium: this.teaserBoxConfig.isPremium,
                showArticleTags: this.teaserBoxConfig.showArticleTags,
                showAuthorAvatar: false,
                showAuthorName: false,
                showCategory: false,
                showPublicationDate: this.teaserBoxConfig.showPublicationDate,
                showTitle: true,
                size: TileSize.S,
                titleOnImage: true,
                titleVersion: this.teaserBoxConfig.titleVersion
            },
            [TileSize.L]: {
                isPremium: this.teaserBoxConfig.isPremium,
                showArticleTags: this.teaserBoxConfig.showArticleTags,
                showAuthorAvatar: this.teaserBoxConfig.showAuthorAvatar,
                showAuthorName: this.teaserBoxConfig.showAuthorName,
                showCategory: this.teaserBoxConfig.showCategory,
                showPublicationDate: this.teaserBoxConfig.showPublicationDate,
                showTitle: true,
                size: TileSize.L,
                titleOnImage: true,
                titleVersion: this.teaserBoxConfig.titleVersion
            }
        };
        this.TileSize = TileSize;
    }
};
TeaserBoxInnerGridL8S.moduleVersion = TeaserBoxVersion['L-8S'];
TeaserBoxInnerGridL8S = __decorate([
    Component({
        name: 'TeaserBoxInnerGridL8S',
        components: { InnerGridWrapper, Tile },
        template: `
    <InnerGridWrapper>
    <template v-if="articles && articles.length">
      <!-- Tile / L -->
      <Tile v-bind="{ ...tileConfig[TileSize.L], fallbackImage, windowService, isLazy, isMobile }" :article="articles[0]" reverseContent />

      <!-- Tiles / S -->
      <Tile v-for="article in articles.slice(1, 9)" :key="article.id"
            v-bind="{ ...tileConfig[TileSize.S], article, fallbackImage, windowService, isLazy, isMobile }" reverseContent />

    </template>
    </InnerGridWrapper>
  `
    })
], TeaserBoxInnerGridL8S);
export { TeaserBoxInnerGridL8S };
